module.exports = __webpack_public_path__ + "img/pp-53.4bfbb81b.jpg";